import { CountUp } from 'countup.js';

export default function initCountUp() {
  const instances = document.querySelectorAll('[data-count]');

  if (!instances.length) return;

  instances.forEach(inst => {
    new CountUp(inst, parseFloat(inst.dataset.value), {
      enableScrollSpy: true,
      scrollSpyOnce: true,
      useGrouping: false,
      prefix: inst.dataset.prefix || '',
      suffix: inst.dataset.suffix || '',
      decimalPlaces: inst.dataset.value.split('.')[1]?.length || 0
    });
  });
}
